<template>
  <div class="page">

    <!-- TODO: Let's make this a separate component altogether. -->
    <intro class="page__intro"
           v-if="page.intro">
    </intro>

    <template v-if="page.map" class="page__map">
      <map-initiatives :mapIndicatorId="page.mapIndicatorId"></map-initiatives>
    </template>

    <chart v-if="page.chartType" class="page__chart"
           :content="page">
    </chart>

    <div class="page__content-items">
      <content-item v-for="(item, index) in page.content"
                    :content="item"
                    :key="index">
      </content-item>
    </div>

  </div>
</template>

<script>
  import Chart from '../Charts/Chart'
  import ContentItem from '../ContentItem/ContentItem'
  import Intro from '../Intro/Intro'
  import MapInitiatives from '../MapInitiatives/MapInitiatives'

  export default {
    name: 'Page',
    components: {
      Chart,
      ContentItem,
      Intro,
      MapInitiatives
    },
    props: {
      page: {
        type: Object,
        required: true
      }
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style src="./Page.scss" lang="scss"></style>
